import { Component, Event, EventEmitter, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-connected-component',
  styleUrl: 'chat-message-connected-module.scss',
  shadow: true,
})
export class ModuleChatMessageConnected {
  private project = window['CURRENT_PROJECT'];

  @Prop() readonly message: IWCChatMessage;
  @Prop() readonly lastMessage: { total: number; index: number };

  @Event() openSupportModuleFaq: EventEmitter<number>;
  @Event() selectValue: EventEmitter<{ value: string; type: string }>;

  private submit(item: IWCChatMessageValue) {
    if (item.type === 'connection') {
      window.location.href =
        wcShared?.store?.productsRouting?.shop + '/auth/login?project=' + this.project;
    } else if (item.type === 'faq') {
      this.openSupportModuleFaq.emit(item.value);
    } else {
      this.selectValue.emit({ value: item.value, type: 'technical_question_menu_reply' });
    }
  }

  render() {
    if (this.message.type === 'technical_question_menu_reply') {
      return wcShared?.translate("Je n'ai pas de compte Infomaniak");
    } else {
      return (
        <Host>
          <div class="connected-title">{this.message?.title}</div>
          <div
            class={{
              'connected-actions': true,
              'connected-actions--vertical': this.message?.action?.length > 2,
            }}
          >
            {(this.message?.action as IWCChatMessageValue[])?.map((item) => {
              return (
                <button
                  type="button"
                  onClick={() => this.submit(item)}
                  disabled={this.lastMessage?.total !== this.lastMessage?.index}
                >
                  {item?.label}
                </button>
              );
            })}
          </div>
        </Host>
      );
    }
  }
}
